(function() {
    'use strict';

    angular.module("imApp").factory("edgeRelationsService", [function() {
        let service = {};

        return service;
    }]);
})();
